import { render, staticRenderFns } from "./liveMatchesTwoPlayerControl.vue?vue&type=template&id=dcf6ba8c&scoped=true"
import script from "./liveMatchesTwoPlayerControl.vue?vue&type=script&lang=js"
export * from "./liveMatchesTwoPlayerControl.vue?vue&type=script&lang=js"
import style0 from "./liveMatchesTwoPlayerControl.vue?vue&type=style&index=0&id=dcf6ba8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf6ba8c",
  null
  
)

export default component.exports